import { render, staticRenderFns } from "./KoreanLsportCartNew.vue?vue&type=template&id=fef13e1e&scoped=true"
import script from "./KoreanLsportCartNew.vue?vue&type=script&lang=js"
export * from "./KoreanLsportCartNew.vue?vue&type=script&lang=js"
import style0 from "./KoreanLsportCartNew.vue?vue&type=style&index=0&id=fef13e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef13e1e",
  null
  
)

export default component.exports